<template>
  <div class="event">
    <p>{{ $store.getters['getClientMeta'].name }}</p>
    <h3 class="line-title">Geçmiş Hareketlerim</h3>

    <form v-on:submit.prevent="filterBtn" class="top-filter">
      <div class="buttons">
        <button  type="button" @click="filter.type = 'financial'" class="button" :class="filter.type == 'financial' ? 'active' : ''">Finansal</button>
        <button  type="button" @click="filter.type = 'sportsbook'" class="button" :class="filter.type == 'sportsbook' ? 'active' : ''">Spor</button>
        <button  type="button" @click="filter.type = 'casino'" class="button" :class="filter.type == 'casino' ? 'active' : ''">Casino</button>
      </div>

      <slot v-if="filter.type != 'sportsbook'">
        <DatePicker 
        
        v-if="!isMobile" 
        format="dd.MM.yyyy" 
          placeholder="Başlangıç Tarihi"
        :full-month-name="true" 
        :monday-first="true" 
        :language="tr" 
        v-model="filter.start_date"/>

        <DatePicker 
        
        v-if="!isMobile" 
        placeholder="Bitiş Tarihi"
        format="dd.MM.yyyy" 
        :full-month-name="true" 
        :monday-first="true" 
        :language="tr" 
        v-model="filter.end_date"/>


      <input v-if="isMobile" v-model="filter.start_date" type="date" placeholder="Bitiş Tarihi">
      <input v-if="isMobile" v-model="filter.end_date" type="date" placeholder="Bitiş Tarihi">
      </slot>
      <ButtonLoader class="primary" :loader="btnLoading" :text="'Filtrele'" >
        <template name="icon">
          <svg x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
        </template>
      </ButtonLoader>
    </form>
    
    <div class="user-content-inc table-panel">
      <Loader v-if="loading" :style="!isMobile ? 'margin-top: -35px;' : ''" />
     <slot v-if="!sportData.config.is_script">
        <slot v-if="!loading">
            <div class="panel" v-if="type == 'casino'">
              <div class="title">
                <div class="col id" v-if="!isMobile">ID</div>
                <div class="col">Sistem</div>
                <div class="col">Bahis</div>
                <div class="col">Tutar</div>
                <div class="col">Bakiye</div>
                <div class="col">Tarih</div>
              </div>
              <div class="content">
                <div class="table-col">
                  <div class="item" v-for="(game, key) in data" :key="key">
                    <div class="col id" v-if="!isMobile">#{{ game.id }}</div>
                    <div class="col"><div v-if="isMobile">#{{ game.id }}</div> <strong>{{ game.provider_name }}</strong></div>
                    <div class="col">{{ game.bet }} {{ user.currency }}</div>
                    <div class="col"><b>{{ game.win }} {{ user.currency }}</b></div>
                    <div class="col"><strong>{{ game.balance }} {{ user.currency }}</strong></div>
                    <div class="col">{{ game.created_at }}</div>
                  </div>
                  <div class="alert"  v-show="_.isEmpty(data)">
                      Sonuç bulunamadı, Lütfen tarih veya arama seçeneklerini kontrol ediniz.
                  </div>
                </div>
              </div>
            </div>
            <div class="panel" v-if="type == 'sportsbook'">
              <div class="title">
                <div class="col id" v-if="!isMobile">ID</div>
                <div class="col">Tür</div>
                <div class="col">Bahis</div>
                <div class="col">Kazanç</div>
                <div class="col">Durum</div>
                <div class="col">Oluşturma</div>
              </div>
              <div class="content">
                <div class="table-col">
                  <div class="item" v-for="(coupon, key) in data" :key="key">
                    <div class="col id" v-if="!isMobile">#{{ coupon.coupon_id }}</div>
                    <div class="col"><div v-if="isMobile">#{{ coupon.coupon_id }}</div> <strong>{{ coupon.coupon_type_name }}</strong></div>
                    <div class="col">{{  coupon.amount }} {{ user.currency }}</div>
                    <div class="col"><b>{{  coupon.estimated }} {{ user.currency }}</b></div>
                    <div class="col"><strong>{{  coupon.status_name }}</strong></div>
                    <div class="col">{{ coupon.created_at }}</div>
                  </div>
                  <div class="alert"  v-show="_.isEmpty(data)">
                      Sonuç bulunamadı, Lütfen tarih veya arama seçeneklerini kontrol ediniz.
                  </div>
                </div>
              </div>
            </div>
            <div class="panel" v-if="type == 'financial'">
              <div class="title">
                <div class="col id" v-if="!isMobile">ID</div>
                <div class="col">Sistem</div>
                <div class="col">Tür</div>
                <div class="col">Tutar</div>
                <div class="col">Durum</div>
                <div class="col">Son Güncelleme</div>
              </div>
              <div class="content">
                <div class="table-col">
                  <div class="item" v-for="(payment,key) in data" :key="key">
                    <div class="col id" v-if="!isMobile">#{{ payment.id }}</div>
                    <div class="col"><div v-if="isMobile">#{{ payment.id }}</div>
                      <strong>
                        <slot v-if="payment.service != 'bank'">{{  payment.service_name }}</slot>
                        <slot v-else>Banka Havalesi - {{ payment.bank_name }}</slot>
                      </strong>
                    </div>
                    <div class="col">{{  $t(payment.type_name) }}</div>
                    <div class="col"><b>{{  payment.amount }} {{ payment.currency }}</b></div>
                    <div class="col">
                      {{  $t(payment.status_name) }}
                      <slot v-if="payment.status_orj == 0 && payment.type == 0 && payment.service != 'manuel'">
                        <a href="javascript:;" v-on:click="cancelWithdrawal(payment.id)" class="button danger">İptal Et</a>
                      </slot>
                    </div>
                    <div class="col">{{ $moment(payment.updated_at).format('MM/DD H:mm:ss') }}</div>
                  </div>
                  <div class="alert"  v-show="_.isEmpty(data)">
                      Sonuç bulunamadı, Lütfen tarih veya arama seçeneklerini kontrol ediniz.
                  </div>
                </div>
              </div>
            </div> 
            <br>
        </slot>
        <div v-show="!loading && !_.isEmpty(data)">
          <paginate
            :page-count="filter.pageTotal"
            :page-range="6"
            :force-page="filter.page"
            :margin-pages="2"
            :click-handler="fetchData"
            :prev-text="'Geri'"
            :next-text="'İleri'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </paginate>
        </div>
     </slot>

			<slot v-if="sportData.config.is_script">
          <div v-if="sportData.config.is_script" v-html-js="{html: sportData.data, script:'javascript'}"></div>
          <iframe v-if="!sportData.config.is_script" :src="sportData.game_url" style="height:1000px" frameborder="0" width="100%"/>
      </slot>
    </div>
  </div>
</template>
<script>
  import DatePicker from 'vuejs-datepicker';
  import {tr, en} from 'vuejs-datepicker/dist/locale'

  import Header from '../../components/Common/User/Header'
  import FilterPanel from '../../components/Common/User/FilterPanel'

  export default{
    data(){
      return{
        type:'financial',
        tr: tr,
        en: en,
        sportData:{
          config:{
            is_script:false
          }
        },
        mobileFilter: false,
        loading: false,
        btnLoading:false,
        data: [],
        filter:{
          pageTotal: 0,
          size: 10,
          page: 1,
          isLoading: false,
          start_date: this.$moment().format('YYYY-MM-DD'),
          end_date: this.$moment().format('YYYY-MM-DD'),
          type: 'financial'
        },
      }
    },
    components:{
      Header,
      FilterPanel,
      DatePicker
    },
    watch:{
      mobileFilter(val){
        if(val){
          document.querySelector("#app").classList.add('lock');
        }else{
          document.querySelector("#app").classList.remove('lock');
        }
      }
    },
    created(){
      this.fetchData()
    },
    computed:{
        user(){
          return this.$user();
        },
    },
    methods:{
        fetchData(page = 1, size = null, silent = false)
        {
          this.filter.page = page;

          if (!_.isNull(size)) 
          {
              this.filter.size = size;
          }
          
          if(silent == false){
            this.loading = true;
          } 
          this.sportData.config.is_script = false;
          axios.get('/user/history', {params: this.filter }).then((response) => {
              if(this.filter.type == 'sportsbook' && !_.isUndefined(response.data.config)){
                this.sportData = response.data
              }
              this.data       					  = response.data.data.data;
              this.filter.pageTotal  = response.data.data.last_page;
              this.type = this.filter.type;

              
          }).catch(() => {}).finally(() => {
              this.loading = false;
              this.btnLoading = false;
          });
          this.mobileFilter = false;
        },
        filter_open(){
          this.mobileFilter = true;
        },
        filterBtn(){
          this.btnLoading = true;
          this.fetchData();
        },
        cancelWithdrawal(transaction_id){
            if (!confirm('Bu işlemi iptal etmek istediğinize emin misiniz?')) {
                return false;
            }
            this.loading = true;

            axios.get('/user/wallet/cancel/' + transaction_id)
                .then((response)=>{
                    this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message });
                    this.fetchData();
                })
                .catch((err)=>{
                })
                .finally(() => {
                  this.loading = false;
                });
        },
    }
  }
 </script>